import React, { useState } from 'react';
import { style } from 'typestyle';
import * as styles from '../../offices/cards/cards.styles';
import OfficeManagerModal from '../modals/office-manager-modal.component';
import type OfficeManagerUser from '../models/officeManagerUser';
import Column from '../../../core/components/column/column.component';
import { MainAxisAlignment } from '../../../core/components/flex/flex.component';
import Row from '../../../core/components/row/row.component';

interface Props {
  readonly user: OfficeManagerUser;
  readonly handleDeleteOfficeManager: (user: OfficeManagerUser) => void;
}

const OfficeManagerCard = ({ user, handleDeleteOfficeManager }: Props): React.JSX.Element => {
  const [showOfficeManagerModal, setShowOfficeManagerModal] = useState(false);

  return (
    <>
      <div
        className={style(styles.infoCard(true))}
        key={user.id}
        onClick={(): void => {
          setShowOfficeManagerModal(true);
        }}
        role="presentation"
      >
        <Column>
          <span className={style(styles.cardHeader(true))}>{user.email}</span>
          <Row mainAxisAlignment={MainAxisAlignment.Stretch}>
            <span className={style(styles.cardBody(true))}>{user.officeName}</span>
          </Row>
        </Column>
      </div>

      <OfficeManagerModal
        showModal={showOfficeManagerModal}
        user={user}
        handleDeleteOfficeManager={handleDeleteOfficeManager}
        handleClose={(): void => {
          setShowOfficeManagerModal(false);
        }}
      />
    </>
  );
};

export default OfficeManagerCard;
